import React, {Component} from "react";

class Toast extends Component {
    render() {
        return (
            <div className={"btoast "+this.props.theme}>
                <p style={{marginBottom: "0", textAlign: "center"}}>{this.props.message}</p>
            </div>
        )
    }
}

export default Toast